<template>
  <div class="btn-group">
    <button v-for="(button, index) of buttons" :key="index" :class="['btn', sizeClass, 'btn-white', index == value ? 'active' : '']" @click.prevent="selectButton(index)" :disabled="disabled">
      <i v-if="buttonHasIcon(button)" :class="['far', button.icon, button.iconClass || '']" :style="button.iconStyle || {}"></i>
      {{buttonName(button)}}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ButtonGroup',
  model: {
    event: 'change'
  },
  props: {
    buttons: Array,
    value: {
      type: Number,
      default: 0
    },
    sizeClass: {
      type: String,
      default: 'btn-xs'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectButton(index) {
      this.$emit('change', index)
    },
    buttonName(button) {
      if(button instanceof Object)
        return button.title
      return button
    },
    buttonHasIcon(button) {
      if(button instanceof Object)
        return !!button.icon
      return false
    }
  }
  

}
</script>